import validationMessages from 'vee-validate/dist/locale/ko';
//citrix.co.kr

const yesNoOptions = [
    {value: "Yes", text: "예"},
    {value: "No", text: "아니오"}
]

export default {
    privacyLinkLabel: "개인정보보호 정책",
    privacyLink: '/ko-kr/about/legal/privacy/',
    privacyText: "귀하의 데이터는당사의",
    privacyText2: "에 따라 Citrix가 처리합니다.",
    resetText: "만약 아래에 미리 입력되어 있는 양식이 귀하의 것이 아닐 경우,",
    resetText2: "하여 초기화하십시오.",
    resetLinkText: "여기를 클릭",
    yes: "예",
    no: "아니오",
    submitBtn: {
        "Submit" : "제출",
        "Get the eBook" : "e-Book 다운로드",
        "Watch demo" : "데모 보기",
        "Get the kit" : "키트 얻기",
        "Request a demo": "데모 체험 요청",
        "Request a call": "전화 상담 신청"
    },
    apjPrivacy:{
        title: "고객의 개인 정보를 사용하는 방법",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") 는 해당 데이터 보호 법률 및 규정 및",
        linkText: "Citrix개인정보보호 정책",
        part2: "에 따라 액세스가 엄격하게 제한되는 상황에서 고객의 개인 정보를 사용하고 저장합니다. Citrix는 개인정보보호 정책에 따라 고객의 개인 정보를 사용하며 다른 목적으로는 사용하지 않습니다. Citrix는 개인정보보호 정책에 따라 국내외 사업체에 개인 정보 처리를 위임하거나, 전세계의 다른 Citrix 지사 또는 자회사와 개인 정보를 공유하거나, 국내외 제3자 업체에 개인 정보를 전송할 수 있습니다. Citrix에 개인 정보를 제출하면 귀하는 Citrix 개인정보보호 정책에 명시된 대로 귀하의 개인 정보를 수집하고 처리하는 데 동의하게 됩니다.",
        privacyAccept: "본인은 Citrix 개인정보보호 정책을 읽었으며 이에 동의합니다."
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "회사"
        },
        "department": {
            label: "부서",
            options: [
                { value: "Application Management", text: "애플리케이션 관리" },
                { value: "Consulting Services", text: "컨설팅 서비스" },
                { value: "Education / Training", text: "교육/훈련" },
                { value: "Engineering", text: "엔지니어링" },
                { value: "Executive Office / Administration", text: "행정 사무실/관리" },
                { value: "Finance / Accounting", text: "금융/회계" },
                { value: "Human Resources", text: "인사" },
                { value: "Information Technology - Systems", text: "정보 기술 시스템" },
                { value: "Legal", text: "법률" },
                { value: "Marketing / PR", text: "마케팅/PR" },
                { value: "Networking", text: "네트워킹" },
                { value: "Operations / Manufacturing", text: "운영/제조" },
                { value: "Pre-Sales / Technical Support", text: "사전 판매/기술 지원" },
                { value: "Project Management", text: "프로젝트 관리" },
                { value: "Purchasing", text: "구매" },
                { value: "Sales / Bus-Corp Development", text: "영업/버스 공사 개발" },
                { value: "Security", text: "보안" },
                { value: "Web / Online / E-Business", text: "웹/온라인/전자 상거래" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "업계",
            options: [
                { value: "Household Services", text: "가사 서비스" },
                { value: "Personnel Services", text: "개인 서비스" },
                { value: "Construction and Design", text: "건축 및 설계" },
                { value: "Utilities", text: "공공시설" },
                { value: "Mining - All", text: "광업 - 모두" },
                { value: "Education", text: "교육" },
                { value: "Finance", text: "금융" },
                { value: "Technology", text: "기술" },
                { value: "Agriculture", text: "농업" },
                { value: "Legal", text: "법률" },
                { value: "Insurance", text: "보험" },
                { value: "Conglomerate", text: "복합 기업" },
                { value: "Real Estate", text: "부동산" },
                { value: "Business Consulting", text: "비즈니스 컨설팅" },
                { value: "Business/Personal Services", text: "비즈니스/개인 서비스" },
                { value: "Service Provider", text: "서비스 공급 업체" },
                { value: "Hospitality", text: "서비스업" },
                { value: "Oil and Gas", text: "석유와 가스" },
                { value: "Retail/Wholesale", text: "소매/도매" },
                { value: "Consumer Packaged Goods", text: "소비재" },
                { value: "Engineering", text: "엔지니어링" },
                { value: "Entertainment", text: "엔터테인먼트" },
                { value: "Art & Membership", text: "예술 & 회원권" },
                { value: "Transportation", text: "운송" },
                { value: "Health Care", text: "의료" },
                { value: "Charitable/Non-Profit", text: "자선 단체/비영리 단체" },
                { value: "Professional Services", text: "전문 서비스" },
                { value: "E-Commerce", text: "전자 상거래" },
                { value: "Government/State-Province", text: "정부/시도 정부" },
                { value: "Government/National-Federal", text: "정부/연방 정부" },
                { value: "Government/Local", text: "정부/지방 정부" },
                { value: "Pharmaceuticals", text: "제약" },
                { value: "Manufacturing", text: "제조" },
                { value: "Publishing/Printing", text: "출판/인쇄" },
                { value: "Telecommunication", text: "통신" },
                { value: "Chemical Manufacturing", text: "화학 제조" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "회사 규모\n",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "회사 규모\n",
            options: [
                { value: "5,001 +", text: "5,001 +" },
                { value: "1,001 to 5,000", text: "1,001 ~ 5,000명" },
                { value: "501 to 1,000", text: "501 ~ 1,000명" },
                { value: "251 to 500", text: "251 ~ 500명" },
                { value: "1 to 250", text: "1 ~ 250명" }
            ]
        },
        "Address2": {
            label: "주소란 2"
        },
        "Address3": {
            label: "주소란 3"
        },
        "city": {
            label: "시"
        },
        "country": {
            label: "국가"
        },
        "email": {
            label: "업무용 이메일"
        },
        "firstName": {
            label: "이름"
        },
        "lastName": {
            label: "성"
        },
        "phone": {
            label: "Phone number"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "우편 번호"
        },
        "salutation": {
            label: "인사말",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "시/도"
        },
        "address": {
            label: "주소"
        },
        "Job_Title__c": {
            label: "직책",
            options: [
                { value: "IT Manager", text: "IT 매니저" },
                { value: "Developer / Programmer", text: "개발자 / 프로그래머" },
                { value: "Architect", text: "건축가" },
                { value: "C-Level / President / VP", text: "경영진 / 사장 / 부사장" },
                { value: "Network Administrator / Engineer", text: "네트워크 관리자 / 엔지니어" },
                { value: "Business Manager", text: "비즈니스 매니저" },
                { value: "Owner / Partner", text: "소유주 / 파트너" },
                { value: "System Administrator", text: "시스템 관리자" },
                { value: "Analyst", text: "애널리스트" },
                { value: "Assistant", text: "어시스턴트" },
                { value: "Director", text: "이사" },
                { value: "Consultant", text: "컨설턴트" },
                { value: "Student", text: "학생" }
            ]
        },
        "Project_Budget__c": {
            label: "프로젝트 예산",
            options: [
                { value: "Yes", text: "예" },
                { value: "No", text: "아니오" },
                { value: "Unknown", text: "알 수 없음" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL 키를 누르고 복수 선택 가능 (최대 5개)"
        },
        "Purchase_Timeframe__c": {
            label: "구매 시간 프레임"
        },
        "Email_Blast_OK__c": {
            label: "이메일을 발송해드릴까요?",
            options: [
                { value: "Yes", text: "예" },
                { value: "No", text: "아니오" },
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "예" },
                { value: "No", text: "아니오" },
            ]
        },
        "OK_to_Call__c": {
            label: "전화로 연락을 드릴까요?",
            options: [
                { value: "Yes", text: "예" },
                { value: "No", text: "아니오" },
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "전화 상담 요청"
        },
        "Comments_6__c":{
            label: "의견"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "모든 마케팅 이메일 커뮤니케이션을 구독 취소합니다.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "30일 간 커뮤니케이션을 일시 중지합니다.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "앱, 데스크탑, 파일 및 모바일 기기 등 전체 디지털 워크스페이스가 어디에서든 최상의 업무 성과를 제공하는 데 도움이 되는 방법.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "어떤 기기에서든 모든 앱, 데스크탑 및 데이터에 안전하게 액세스하는 방법.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "하이브리드, 멀티 클라우드 환경에서 모놀리식 및 마이크로서비스 기반 앱 딜리버리를 관리하는 방법.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "사용자들에게 필요한 상시 접속 고성능 네트워크를 제공하는 방법.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "분석과 인사이트를 통해 보안 위협 및 성능 이상이 발생하기 전에 감지하여 차단하는 방법.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "구독 취소",
        thankyou: "이메일 기본 설정이 업데이트되었습니다. 실수로 업데이트했거나 기본 설정을 검토하려면 언제든지 기본 설정 센터를 방문해 주십시오.",
        formDescription: "구독을 취소하셨습니다. 필요한 것이 계시면 언제든지 Citrix.com에 방문해 주십시오. Citrix는 귀하에게 적합한 솔루션을 제공드리기 위해 지속적으로 새로운 특징과 기능을 추가하고 있습니다.",

    },
    preferenceCenter: {
        formTitle: "Citrix 이메일 기본 설정 센터",
        thankyou: "<h3>구독 변경이 확인되었습니다!</h3><p>이메일 기본 설정이 업데이트되었습니다.</p>",
        formDescription: "Citrix는 고객이 희망하는 이메일 및 커뮤니케이션 설정을 중요하게 생각합니다. Citrix는 귀하와 귀사가 더 나은 업무 방식을 구현하는 데 도움이 되는 정보를 보내드리고자 합니다. 귀하의 관심분야에 맞는 Citrix의 커뮤니케이션을 수신하시려면 이메일 기본 설정을 업데이트해 주십시오.",
        labelOne: "추가 정보",
        labelTwo: "어떤 주제에 대한 소식에 가장 관심이 있으십니까?",
        labelThree: "어떤 방식의 커뮤니케이션을 희망하십니까?",
    },
    validation: validationMessages
}